class FooterShowMore {
  constructor() {
    this.footer = document.querySelector('.footer-show-more');
    this.showMoreBtn = document.querySelector('.footer__btnShow');
    this.isExpanded = false;

    if (this.footer && this.showMoreBtn) {
      this.init();
    }
  }

  init() {
    this.setupEventListeners();
    this.updateButtonText();
  }

  setupEventListeners() {
    this.showMoreBtn.addEventListener('click', () => this.toggleColumns());
  }

  toggleColumns() {
    this.isExpanded = !this.isExpanded;
    this.footer.classList.toggle('is-expanded', this.isExpanded);
    this.updateButtonText();
  }

  updateButtonText() {
    this.showMoreBtn.textContent = this.isExpanded ? window.glblMessages?.[window.locale].collapseBtn : window.glblMessages?.[window.locale].expandBtn;
    this.showMoreBtn.classList.toggle('footer__btnShow_expanded', this.isExpanded);
  }
}

// Initialize the component
document.addEventListener('DOMContentLoaded', () => {
  new FooterShowMore();
});
